// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.htmlviewer-public-container .htmlviewer-cta[data-v-285ca284]{display:flex;justify-content:center}`, "",{"version":3,"sources":["webpack://./src/PublicPage.vue"],"names":[],"mappings":"AAEI,8DACI,YAAA,CACA,sBAAA","sourcesContent":["\n.htmlviewer-public-container {\n    .htmlviewer-cta {\n        display         : flex;\n        justify-content : center;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
